import { MathJax } from "better-react-mathjax";

export const shuffleArray = (array) => {
  return [...array].sort(() => Math.random() - 0.5);
}

export const convertMathJax = (detail) => {
  return <MathJax dynamic>{detail}</MathJax>
}

export const escapeHTML = (str) => {
  return str
    // .replace(/&/g, '&amp;')
    // .replace(/</g, '&lt;')
    // .replace(/>/g, '&gt;')
    // .replace(/"/g, '&quot;')
    // .replace(/'/g, '&#39;')
    .replace(/_/g, '&#95;'); // Optional: escape underscore
}
